<template>
	<main class="wrapper">
		<page-head>
            <el-form class="search-form" slot="left" label-width="85px">
                <x-form
                    label="书友ID"
                    v-model="searchModel.uid"
                    placeholder="输入书友ID"
                    clearable
                ></x-form>
                <x-form
                    label="评论内容"
                    v-model="searchModel.content"
                    placeholder="输入评论内容"
                    clearable
                ></x-form>
               
               
                <el-button type="primary" @click="fetchList">查询</el-button>
            </el-form>
        </page-head>
		<x-table
			:tableData="tableData"
			:tableHeaders="tableHeaders"
			:clickData="clickData"
			@clickRight="clickRight"
			:total="total"
			:pageModel="pageModel"
			:fetchList="fetchList"
		></x-table>
	</main>
</template>

<script type="text/javascript">
import {
	commentList,
	deleteComment,
} from '@/api/people'
export default {
	data() {
		return {
			searchModel: {},
			tableData: [],
			tableHeaders: [{
				headerKey: 'uid',
				headerName: '用户ID',
				width: 60
			}, {
				headerKey: 'realname',
				headerName: '用户名',
				width: 100
			}, {
				headerKey: 'nickname',
				headerName: '用户昵称',
				width: 100
			}, {
				headerKey: 'count_like',
				headerName: '点赞数',
				width: 60
			}, {
				headerKey: 'count_comment',
				headerName: '评论数',
				width: 60
			}, {
				headerKey: 'content',
				headerName: '评论内容'
			}],
			pageModel: {
				page: 1,
				size: 20
			},
			clickData: [{
				label: '删除',
				value: 'del',
				type: 'text',
				color: 'red'
			}],
			total: 0
		}
	},
	methods: {
		fetchList() {
			commentList({
				...this.pageModel,
				...this.searchModel,
			}).then(res => {
				this.tableData = res.data.list
				this.total = res.data.total
			})
		},
		clickRight({type, row}) {
			this.$confirm('确认删除吗？', '你想好了吗？用户数据不可轻易删除', {
				type: 'warning'
			}).then(res => {
				deleteComment({
					id: row.id
				}).then(res => {
					this.$message.success('删除成功！')
					this.fetchList()
				})
			})
		}
	},
	mounted() {
		this.fetchList()
	}
}
</script>

<style lang="less">
	
</style>